export default __webpack_public_path__ + "static/media/hörtest-avatar-05.dc20500c.svg";